import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { useFilterContext } from "~/components/FilterWrapper/FilterWrapper"
import { Heading } from "~/components/Heading/Heading"

import styles from "./index.module.css"

type Props = {
  activeLabel: string
  closedLabel: string
}

export const StatusFilter: React.FC<Props> = ({ activeLabel, closedLabel }) => {
  const { updateFilterState, filterState } = useFilterContext()
  const { t } = useTranslation()
  const statuses: { label: string; name: "active" | "closed" | "all" | undefined }[] = [
    {
      name: "active",
      label: activeLabel,
    },
    // {
    //   name: "closed",
    //   label: closedLabel,
    // },
    // {
    //   name: "all",
    //   label: t("FilterWrapper.StatusFilter.Label.All"),
    // },
  ]

  return (
    <div className={styles.FilterByStatus}>
      {statuses.map(({ name, label }, i) => (
        <Heading
          key={i}
          className={cn(styles.Status, { [styles.Active]: filterState.status === name })}
          like="h3"
        >
          <span onClick={() => updateFilterState({ status: name })}>{label}</span>
        </Heading>
      ))}
    </div>
  )
}

export const MediaStatusFilter: React.FC = () => {
  const { updateFilterState, filterState } = useFilterContext()
  const { t } = useTranslation()
  const statuses: { label: string; name: "video" | "gallery" | "all" | undefined }[] = [
    {
      name: "all",
      label: t("FilterWrapper.StatusFilter.Label.All"),
    },
    {
      name: "gallery",
      label: t("FilterWrapper.StatusFilter.Label.Gallery"),
    },
    {
      name: "video",
      label: t("FilterWrapper.StatusFilter.Label.Video"),
    },
  ]

  return (
    <div className={styles.FilterByStatus}>
      {statuses.map(({ name, label }, i) => (
        <Heading
          key={i}
          className={cn(styles.Status, { [styles.Active]: filterState.mediaStatus === name })}
          like="h3"
        >
          <span onClick={() => updateFilterState({ mediaStatus: name })}>{label}</span>
        </Heading>
      ))}
    </div>
  )
}
